import { useEffect } from "react";

/**
 * Titre, description, canonique et données structurées d'une page publique.
 *
 * Le site est une application React sans rendu serveur : le HTML de départ est
 * toujours celui d'index.html. Google exécute le JavaScript et voit donc ce que
 * ce hook pose, mais les aperçus qui ne l'exécutent pas (certains robots de
 * réseaux sociaux) restent sur le titre générique. Pour une page de contenu
 * qu'on veut voir se classer, c'est suffisant ; si un jour il en faut mieux, ça
 * passera par un pré-rendu au moment du build, pas par plus de balises ici.
 *
 * Tout est retiré au démontage pour qu'une page ne laisse pas son titre ni son
 * bloc JSON-LD à la suivante.
 */
export function useSeo({ titre, description, canonique, donnees }) {
  useEffect(() => {
    const titreAvant = document.title;
    if (titre) document.title = titre;

    const poserMeta = (nom, contenu) => {
      if (!contenu) return null;
      let el = document.querySelector(`meta[name="${nom}"]`);
      const precedent = el ? el.getAttribute("content") : null;
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", nom);
        document.head.appendChild(el);
      }
      el.setAttribute("content", contenu);
      return () => {
        if (precedent === null) el.remove();
        else el.setAttribute("content", precedent);
      };
    };

    const defaireDesc = poserMeta("description", description);

    let lien = null;
    if (canonique) {
      lien = document.createElement("link");
      lien.setAttribute("rel", "canonical");
      lien.setAttribute("href", canonique);
      document.head.appendChild(lien);
    }

    let script = null;
    if (donnees) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.textContent = JSON.stringify(donnees);
      document.head.appendChild(script);
    }

    return () => {
      document.title = titreAvant;
      if (defaireDesc) defaireDesc();
      if (lien) lien.remove();
      if (script) script.remove();
    };
  }, [titre, description, canonique, donnees]);
}
